import React from "react";

const NoPage = () => {

    return (
        <div>
            <title>PAGE DOES NOT EXIST (404)</title>
        </div>
    );
};

export default NoPage;